// extracted by mini-css-extract-plugin
export var avatarContainer = "_cg-0";
export var avatarTypingWave = "_cg-i";
export var gray = "_cg-f";
export var green = "_cg-c";
export var icon = "_cg-9";
export var image = "_cg-1";
export var lg = "_cg-6";
export var md = "_cg-5";
export var presenceDot = "_cg-b";
export var red = "_cg-d";
export var sm = "_cg-4";
export var status = "_cg-a";
export var typingDot = "_cg-h";
export var typingPill = "_cg-g";
export var xl = "_cg-7";
export var xs = "_cg-3";
export var xxl = "_cg-8";
export var xxs = "_cg-2";
export var yellow = "_cg-e";